import CadastroVendaModal from './CadastroVendaModal';

export default CadastroVendaModal;
